import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import {
  CreateMachineGroupPayload,
  MachineGroup,
} from "@src/types/namespace-configuration";

export interface CreateMachineGroupResult {
  success: boolean;
  data?: MachineGroup;
  error?: string;
}

export const createMachineGroupUseCase = async (
  payload: CreateMachineGroupPayload,
): Promise<CreateMachineGroupResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const machineGroup = await apiUseCases.postCreateMachineGroup(
      namespace,
      payload,
    );

    return {
      success: true,
      data: machineGroup,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to create machine group")
        .message,
    };
  }
};
